import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { libraryShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';
import { LinkedPill } from '@bibliocommons/pill';
import { bindAll } from '@bibliocommons/utils-react';
import { ChevronLink } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import CommunityDisclaimer from 'app/components/bibs/shared/ugc/CommunityDisclaimer';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import { tagShape } from 'app/shapes/bibPage';
import { AllCommunityTagsContainer } from './AllCommunityTags';
import TagList from './TagList';

import './CommunityTags.scss';

export default class CommunityTags extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      open: false
    };
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  renderPillTags() {
    return <TagList metadataId={this.props.metadataId} tags={this.props.tags} tagType={LinkedPill} />;
  }

  renderOverlay() {
    if (this.props.pagination.get('pages') > 1) {
      return (
        <div className="overlay-wrapper">
          <ChevronLink
            className="view-expand-link"
            href="#view-expand-link"
            dataKey="view-expand-link"
            handleClick={this.handleOpen}
            preventDefault
          >
            <span aria-hidden>
              <FormattedMessage id="view_all" />
            </span>
            <ScreenReaderMessage>
              <FormattedMessage id="view_all_tags" />
            </ScreenReaderMessage>
          </ChevronLink>
          <FullScreenOverlayContainer
            open={this.state.open}
            handleClose={this.handleClose}
            overlayKey="all-community-tags-full-screen-overlay"
            dataKey="all-community-tags-full-screen-overlay"
          >
            {this.state.open && <AllCommunityTagsContainer metadataId={this.props.metadataId} />}
          </FullScreenOverlayContainer>
        </div>
      );
    }

    return null;
  }

  render() {
    if (this.props.tags.size === 0) return null;

    const { currentLibrary } = this.props;

    return (
      <div className="cp-community-tags">
        <div className="community-tags-heading">
          <Heading tagName="h3" size="medium" variant>
            <FormattedMessage id="community_tags" />
          </Heading>
          {currentLibrary?.get('ugcDisclaimerMessageEnabled') && (
            <CommunityDisclaimer type="community_tags" currentLibrary={currentLibrary} />
          )}
          {this.renderPillTags()}
        </div>
        {this.renderOverlay()}
      </div>
    );
  }
}

CommunityTags.propTypes = {
  currentLibrary: libraryShape.isRequired,
  metadataId: PropTypes.string.isRequired,
  pagination: ImmutablePropTypes.map,
  tags: ImmutablePropTypes.listOf(tagShape).isRequired
};
